import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useSubsidiariesData } from "./SubsidiariesDynamic.hook";
import { fields, fieldsReady } from "./constants";
import { toCamelCase, toPascalCase } from "../CorporateProfile/OurPolicies/OurPoliciesDynamic";
import { SubsidiariesPageHeading } from "../Subsidiaries/SubsidiariesPageHeading/SubsidiariesPageHeading";
import { toUniqueKey } from "../Sustainbility/Community/MainContent/MainContent";
import { Language } from "../CorporateProfile/Corporate.hook";
export const SubsidiariesDynamic: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const { data: profileData, isLoading: isLoadingProfile, refetch: refetchOurProfile } = useSubsidiariesData();
  const {
    data: profileDataById,
    isLoading: isLoadingprofileById,
    refetch: refetchOurProfileById,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("profileDataById", profileDataById, profileData);

  useEffect(() => {
    if (query?.get("id")) {
      let parsedEnglish = null;
      try {
        parsedEnglish = profileDataById?.payload?.field_content_english
          ? JSON.parse(profileDataById.payload.field_content_english)
          : { data: { items: [], nextPage: {} } };
      } catch (e) {
        console.error("Error parsing field_content_english:", e);
        parsedEnglish = { data: { items: [], nextPage: {} } };
      }

      let parsedMalay = null;
      try {
        parsedMalay = profileDataById?.payload?.field_content_malay
          ? JSON.parse(profileDataById.payload.field_content_malay)
          : { data: { items: [], nextPage: {} } };
      } catch (e) {
        console.error("Error parsing field_content_malay:", e);
        parsedMalay = { data: { items: [], nextPage: {} } };
      }

      let parsedMandarin = null;
      try {
        parsedMandarin = profileDataById?.payload?.field_content_mandarin
          ? JSON.parse(profileDataById.payload.field_content_mandarin)
          : { data: { items: [], nextPage: {} } };
      } catch (e) {
        console.error("Error parsing field_content_mandarin:", e);
        parsedMandarin = { data: { items: [], nextPage: {} } };
      }

      setPayloadData([
        {
          id: profileDataById?.payload?.id,
          title: profileDataById?.payload?.title,
          field_content_english: parsedEnglish,
          field_content_malay: parsedMalay,
          field_content_mandarin: parsedMandarin,
          field_page: profileDataById?.payload?.field_page,
          published: profileDataById?.payload?.published,
          createdAt: profileDataById?.payload?.createdAt,
          updatedAt: profileDataById?.payload?.updatedAt,
        },
      ]);
    } else {
      setPayloadData(profileData);
    }
  }, [profileData, profileDataById]);

  useEffect(() => {
    if (approveId) {
      refetchOurProfileById();
    } else {
      refetchOurProfile();
    }
  }, [query.get("activeTab"), approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const NextPageFormConfig: FormConfig = {
    initialValues: {
      "field_content_english.data.nextPage.name": (() => {
        try {
          if (profileDataById?.payload?.field_content_english) {
            const parsed = JSON.parse(profileDataById.payload.field_content_english);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing English nextPage name:", error);
          return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_english.data.nextPage.link": (() => {
        try {
          if (profileDataById?.payload?.field_content_english) {
            const parsed = JSON.parse(profileDataById.payload.field_content_english);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing English nextPage link:", error);
          return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
        }
      })(),

      "field_content_malay.data.nextPage.name": (() => {
        try {
          if (profileDataById?.payload?.field_content_malay) {
            const parsed = JSON.parse(profileDataById.payload.field_content_malay);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing Malay nextPage name:", error);
          return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_malay.data.nextPage.link": (() => {
        try {
          if (profileDataById?.payload?.field_content_malay) {
            const parsed = JSON.parse(profileDataById.payload.field_content_malay);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing Malay nextPage link:", error);
          return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
        }
      })(),

      "field_content_mandarin.data.nextPage.name": (() => {
        try {
          if (profileDataById?.payload?.field_content_mandarin) {
            const parsed = JSON.parse(profileDataById.payload.field_content_mandarin);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing Mandarin nextPage name:", error);
          return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_mandarin.data.nextPage.link": (() => {
        try {
          if (profileDataById?.payload?.field_content_mandarin) {
            const parsed = JSON.parse(profileDataById.payload.field_content_mandarin);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing Mandarin nextPage link:", error);
          return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
        }
      })(),
    },
    fields: fields?.nextPageSubsidiaries,
  };

  console.log("NextPageFormConfig", NextPageFormConfig.fields, NextPageFormConfig.initialValues);

  const createFormConfig = (name?: string, idx1?: any, field?: any): FormConfig => {
    const getMarkupValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.markup);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.markup);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.items?.[idx1]?.markup);
    };

    const getTabNameValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.title);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.title);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.items?.[idx1]?.title);
    };

    return {
      initialValues: {
        [`field_content_english.data.items[${idx1}].markup`]: getMarkupValue("field_content_english"),
        [`field_content_malay.data.items[${idx1}].markup`]: getMarkupValue("field_content_malay"),
        [`field_content_mandarin.data.items[${idx1}].markup`]: getMarkupValue("field_content_mandarin"),
        [`field_content_english.data.items[${idx1}].title`]: getTabNameValue("field_content_english"),
        [`field_content_malay.data.items[${idx1}].title`]: getTabNameValue("field_content_malay"),
        [`field_content_mandarin.data.items[${idx1}].title`]: getTabNameValue("field_content_mandarin"),
      },
      fields: field,
    };
  };

  const updatePayload = (data: any) => {
    console.log("Data for... 1", data);
    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (key.includes(".")) {
          const topLevelKey = key.split(".")[0];
          if (obj[topLevelKey] && typeof obj[topLevelKey] === "object") {
            continue;
          }

          const parts = key.split(".");
          let current = result;

          for (let i = 0; i < parts.length - 1; i++) {
            current[parts[i]] = current[parts[i]] || {};
            current = current[parts[i]];
          }

          current[parts[parts.length - 1]] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};

      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key];
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const replacePayload = (target: any, source: any) => {
      for (const key in source) {
        if (source[key] instanceof Object && target[key]) {
          replacePayload(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    };

    const convertedData = convertDotNotation(data);
    const filteredData = filterNestedObjects(convertedData);
    console.log("Data for... 2", data, convertedData, filteredData);
    const payload = { ...payloadData[0] };
    replacePayload(payload, filteredData);
    console.log("Data for... 3", data, payload);
    if (payload.field_content_english) {
      payload.field_content_english = JSON.stringify(payload.field_content_english);
    }
    if (payload.field_content_malay) {
      payload.field_content_malay = JSON.stringify(payload.field_content_malay);
    }
    if (payload.field_content_mandarin) {
      payload.field_content_mandarin = JSON.stringify(payload.field_content_mandarin);
    }
    return payload;
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const activeTab = query.get("activeTab");
    let idx1: number | undefined;
    const payloadData = await updatePayload(data);
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else if (field[0].url) {
            data[key] = field[0].url;
          }
        }
      } catch (error) {}
    }
    let computedSubModule = `subsidiaries_${activeTab}`;
    if (activeTab && activeTab !== "nextPage") {
    try {
        const match = activeTab.match(/ForSubsidiaries_(\d+)$/);
        idx1 = match ? parseInt(match[1], 10) : undefined;
        const englishJson = payloadData?.field_content_english
        ? JSON.parse(payloadData.field_content_english)
        : undefined;
        const currentIndex = englishJson?.data?.items?.[idx1 || 0]?.title;
        if (currentIndex) {
            computedSubModule = `subsidiaries_${toCamelCase(currentIndex)}ForSubsidiaries_${idx1}`;
        }
    } catch (e) {
        computedSubModule = `subsidiaries_${activeTab}`;
    }
    }
    const payload = {
        action: action,
        method: method,
        module: "Subsidiaries",
        subModule: computedSubModule,
        type: "DEDICATED",
        moduleKey: "MAHB_CORPORATE_Subsidiaries",
        application: "MAHB_CORPORATE",
        reviewNotes: reviewNotes,
        appList: [
          {
            appName: "MAHB_CORPORATE",
            apiUrl: apiUrl,
          },
        ],
        payload: payloadData,
        status: status,
      };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => ({
    label,
    key,
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
        }
        defaultReviewNotes="Kindly review this Subsidiaries"
      />
    ),
  });

  const profileChildItems = profileData
    ? profileData?.[0]?.field_content_english?.data?.items.filter(Boolean).map((item: any, index: any) => {
        const uniqueKey = `${toCamelCase(item.title)}ForSubsidiaries_${index}`;
        const pascalCaseConfigName = `${toPascalCase(item.key)}ForSubsidiariesFormConfig`;
        return generateFormItem(
          item.title,
          uniqueKey,
          createFormConfig(item.title, [index], fieldData?.subsidiaries?.[index]),
          `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`
        );
      })
    : (() => {
        const fieldContent = profileDataById?.payload?.field_content_english;
        let parsedContent;
        console.log("fieldContent", fieldContent);
        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }
        console.log("parsedContent", parsedContent);
        return (
          parsedContent?.data?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item?.title)}ForSubsidiaries_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item?.key)}ForSubsidiariesFormConfig`;
            console.log("profileChildItems", item, uniqueKey);
            return generateFormItem(
              item?.title,
              uniqueKey,
              createFormConfig(item?.title, [index], fieldData?.subsidiaries?.[index]),
              `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`
            );
          }) || []
        );
      })();

  profileChildItems.push(
    generateFormItem(
      "Next Page",
      "nextPage",
      NextPageFormConfig,
      `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "64"}`
    )
  );

  profileChildItems.unshift({
    label: "Page Heading",
    key: "subsidiariesPageHeading",
    children: <SubsidiariesPageHeading />,
  });

  if (isLoadingprofileById || isLoadingProfile) {
    return <Loader />;
  }

  return (
    <ContentWrapper
    title="Subsidiaries"
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={profileChildItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
